import React, { PropTypes } from 'react';
import cx from 'classnames';

const SiteSelectorItem = ({ site, value, onChange, error }) => {
  const onCheckboxChange = val => onChange(site, value);

  const fieldClasses = cx('four wide column field', {
    error: error,
  });

  return (
    <div className={fieldClasses}>
      <div className="ui checkbox">
        <input type="checkbox" checked={value} onChange={onCheckboxChange} />
        <label>{site.name}</label>
      </div>
    </div>
  );
};

SiteSelectorItem.propTypes = {
  site: PropTypes.object.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

export default SiteSelectorItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/components/SiteSelectorItem.js